import React from "react";
import { Link } from "react-router-dom";

export const Logo = ({ to = "/" }) => (
  <Link to={to} data-testid="tag-logo" style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
    <img
      src="/tag-logo.png"
      alt="The Authority Gap"
      style={{ width: 32, height: 32, display: "block", objectFit: "contain" }}
    />
    <span style={{ color: "#fff", fontSize: 15, fontWeight: 700 }}>The Authority Gap</span>
  </Link>
);
